import { InjectionToken, Type } from '@angular/core';

/**
 * Injection token for mapping suggestion types to p-icon names.
 *
 * The lib must remain generic and not hardcode suggestion type values.
 * The host app provides the actual type→icon mapping (e.g., { search: 'search', success_center: 'life-buoy' }).
 *
 * Unknown types fall back to a default icon ('message-square').
 *
 * @example
 * // In host app module/config:
 * {
 *   provide: SUGGESTION_ICON_MAP,
 *   useValue: {
 *     search: 'search',
 *     success_center: 'message-square'
 *   }
 * }
 */
export const SUGGESTION_ICON_MAP = new InjectionToken<Record<string, string>>('SUGGESTION_ICON_MAP', {
    providedIn: 'root',
    factory: (): Record<string, string> => ({})
});

/**
 * A component rendered at the end of the chat log, under the last message, such as the canvas draft card that
 * `provideCanvasDraft()` (`@panaya/ai-chat/canvas-draft`) provides. `null`, the default, renders nothing.
 */
export const AI_CHAT_LOG_FOOTER_COMPONENT = new InjectionToken<Type<unknown> | null>('AI_CHAT_LOG_FOOTER_COMPONENT', {
    providedIn: 'root',
    factory: (): Type<unknown> | null => null
});
